import axios from 'axios'
import React, { useState } from 'react';
import { Box, Button } from 'rebass';
import { TextField } from '~/Form';
import { toast } from 'react-toastify';
import CredentialsLayout from '../CredentialsLayout/CredentialsLayout';
import LoginTwoFactorChallenge from '../LoginTwoFactorChallenge';
import { updateUserStore } from '@util/Functions';

const Register = ({ route }) => {
    const [password, setPassword] = useState('')
    const [passwordConfirmation, setPasswordConfirmation] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [step, setStep] = useState(1)
    const [errors, setErrors] = useState({})

    const handleSubmit = (e) => {
        e.preventDefault()
        setIsSubmitting(true)

        axios.post(decodeURIComponent(route), {
            password: password,
            password_confirmation: passwordConfirmation,
            device_name: 'app'
        })
            .then(({ data }) => {
                localStorage.setItem('authToken', data.authToken)

                if (data?.two_factor) {
                    localStorage.setItem('authTokenScope', 'twoFactorRequired')
                    setStep(2)
                } else {
                    localStorage.setItem('authTokenScope', 'full')
                    updateUserStore()
                }
            })
            .catch(({ response }) => {
                response?.data?.errors && setErrors(response.data.errors)
                toast.error(response?.data?.message || 'There was an unexpected error while trying to register')
            })
            .finally(() => setIsSubmitting(false))
    }

    const back = (e) => {
        e.preventDefault();

        if (step > 1) {
            localStorage.removeItem('authTokenScope');
            localStorage.removeItem('authToken');
            setStep(step - 1);
        }
    };

    const content = () => {
        switch (step) {
            case 1:
                return (
                    <CredentialsLayout
                        heading="Complete Your Registration"
                        subheading="Please enter your new password"
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                        footerButton={{ link: '/', title: 'Login Page' }}
                    >
                        <Box mb={2}>
                            <TextField
                                placeholder='Password'
                                name='password'
                                value={password}
                                type='password'
                                onChange={(val) => setPassword(val)}
                                label='Password'
                                errors={errors.password}
                            />
                            <TextField
                                placeholder='Confirm Password'
                                name='passwordConfirmation'
                                value={passwordConfirmation}
                                type='password'
                                onChange={(val) => setPasswordConfirmation(val)}
                                label='Confirm Password'
                                errors={errors.password_confirmation}
                            />

                            {isSubmitting ? (
                                <Button variant="submitting" width="100%" disabled="disabled">Submitting...</Button>
                            ) : (
                                <Button variant="primary" width="100%">Confirm password</Button>
                            )}
                        </Box>
                    </CredentialsLayout>
                );
            case 2:
                return <LoginTwoFactorChallenge twoFactorConfirmed={false} handleBack={back} />;
            default:
                return <></>;
        }
    };

    return <>{content()}</>;
};

export default Register;
